import { useMutation, useQueryClient } from 'react-query';
import organizationApi from '@shared/api/organizationApi';
import { useDispatch } from 'react-redux';
import { dialogTypes, snackbarTypes } from '@/constants/alertTypes';
import alertsUtil from '@/util/alertsUtil';

type WebhookSecretUpdates = {
  secrets: {
    secretName: string;
    secretValue: string | null;
  };
};

const useUpdateWebhookSecrets = (organizationId: string) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(
    ({ secrets }: { secrets: WebhookSecretUpdates }) =>
      organizationApi.updateWebhookSecrets({ organizationId, secrets }),
    {
      onMutate: async () => {
        await queryClient.cancelQueries(['webhook-secrets', organizationId]);
      },
      onSuccess: () => {
        dispatch(
          alertsUtil.openSnackbarDialog(
            snackbarTypes.SUCCESS_API_RESPONSE,
            'Secret keys were updated successfully.'
          )
        );
      },
      onError: () => {
        dispatch(
          alertsUtil.openErrorDialog(
            dialogTypes.CATCH_ERROR_API,
            'There was an error updating your webhook.'
          )
        );
      },
      onSettled: async () => {
        await queryClient.invalidateQueries([
          'webhook-secrets',
          organizationId
        ]);
      }
    }
  );
};

export default useUpdateWebhookSecrets;
